import React from 'react';
import ButtonLink from 'reactApp/ui/ButtonLink/ButtonLink';

export default () => {
    return (
        <span>
            В&nbsp;случае возникновения проблем с&nbsp;оплатой вы&nbsp;можете обратиться в&nbsp;
            <ButtonLink
                inline
                href="https://help.mail.ru/cloud_web/size/increase#trouble"
                target="_blank"
                size="big"
                rel="noopener noreferrer"
                primary
            >
                службу поддержки
            </ButtonLink>
            .
        </span>
    );
};
